"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = require("./AudioManager");
var BoardState_1 = require("./board/BoardState");
var ConnectionManager_1 = require("./ConnectionManager");
var GameConstants_1 = require("./GameConstants");
var GameVars_1 = require("./GameVars");
var LocalServer_1 = require("./LocalServer");
var Boot = /** @class */ (function (_super) {
    __extends(Boot, _super);
    function Boot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Boot.prototype.init = function () {
        var w = window;
        w.onGameInit = ConnectionManager_1.ConnectionManager.setPropertiesOnGameInit;
        Boot.currentInstance = this;
        this.input.maxPointers = 1;
        this.game.stage.disableVisibilityChange = true;
        // por el problema del stock browser
        this.game.stage.backgroundColor = "#000000";
        this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
        this.game.scale.pageAlignHorizontally = true;
        if (this.game.device.desktop) {
            GameVars_1.GameVars.scaleY = 1;
            this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
            this.game.scale.pageAlignHorizontally = true;
        }
        else {
            this.game.scale.scaleMode = Phaser.ScaleManager.EXACT_FIT;
            var isPortait = window.innerHeight > window.innerWidth;
            if (isPortait) {
                GameVars_1.GameVars.scaleY = (4 / 3) / (window.innerHeight / window.innerWidth);
            }
            else {
                GameVars_1.GameVars.scaleY = (4 / 3) / (window.innerWidth / window.innerHeight);
            }
            this.game.scale.pageAlignHorizontally = true;
            // this.game.scale.isPortrait = false;
            this.game.scale.forceOrientation(true, false);
        }
        this.game.onBlur.add(function () { gamezop.mute(); }, this);
        this.game.onFocus.add(function () { gamezop.unmute(); }, this);
        // this.game.onPause.add(() => {gamezop.mute(); }, this);     
        // this.game.onResume.add(() => {gamezop.unmute(); }, this);
        GameConstants_1.GameConstants.DEALPILE_Y *= GameVars_1.GameVars.scaleY;
        if (GameConstants_1.GameConstants.DEVELOPMENT) {
            // para poder medir las fps
            this.game.time.advancedTiming = true;
        }
        window.addEventListener("resize", this.onOrientationChange.bind(this));
        this.resizeCall();
        // this.initResize();
        this.onOrientationChange(false);
        this.scale.setResizeCallback(this.resizeCall, this);
    };
    Boot.prototype.preload = function () {
        this.load.image("load", "assets/load_icon.png");
        this.load.image("bg", "assets/bg.png");
        this.game.add.text(-200, -200, "hack", { font: "1px gangofthree", fill: "#000000" });
    };
    Boot.prototype.create = function () {
        this.gzpInit();
        // this.game.state.start("PreLoader", true, false);
        console.log("build version 0.1.2");
    };
    Boot.prototype.shutdown = function () {
        Boot.currentInstance = null;
        _super.prototype.shutdown.call(this);
    };
    Boot.prototype.gzpInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this, sdkData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, gamezop.Initialize({
                                apiKey: "57d370d9-d604-4b6b-8628-95ee800b2386",
                                gameCode: "rkPlk2T7qAr",
                                debug: true,
                                gameInit: function (matchData) {
                                    if (gamezop.isBattleGame())
                                        ConnectionManager_1.ConnectionManager.setPropertiesOnGameInit(matchData);
                                    else {
                                        LocalServer_1.LocalServer.ResetTimer();
                                        BoardState_1.BoardState.currentInstance.game.state.start("BoardState", true, false);
                                    }
                                },
                                getGameConfig: function () {
                                    return Math.ceil(Math.random() * 500).toString();
                                },
                                gameEnd: function () {
                                    ConnectionManager_1.ConnectionManager.onGameEnd();
                                },
                                replay: function () {
                                    LocalServer_1.LocalServer.ResetTimer();
                                    BoardState_1.BoardState.currentInstance.game.state.start("BoardState", true, false);
                                },
                                gameContinue: function (d) {
                                    BoardState_1.BoardState.currentInstance.game.state.start("BoardState", true, false);
                                },
                                play: function () {
                                    GameVars_1.GameVars.paused = false;
                                },
                                pause: function () {
                                    GameVars_1.GameVars.paused = true;
                                },
                                mute: function () {
                                    try {
                                        AudioManager_1.AudioManager.getInstance().mute();
                                    }
                                    catch (e) {
                                        // 
                                    }
                                },
                                unmute: function () {
                                    try {
                                        if (GameVars_1.GameVars.sound) {
                                            AudioManager_1.AudioManager.getInstance().unmute();
                                        }
                                    }
                                    catch (e) {
                                        // 
                                    }
                                }
                            })];
                    case 2:
                        sdkData = _a.sent();
                        return [4 /*yield*/, _this.onSdkInitialize(sdkData)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.warn("Cant load game", e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Boot.prototype.onSdkInitialize = function (protoData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("protoData", protoData);
                        if (!protoData) return [3 /*break*/, 2];
                        oMetaManager.sync();
                        return [4 /*yield*/, ConnectionManager_1.ConnectionManager.setGzpId()];
                    case 1:
                        _a.sent();
                        GameVars_1.GameVars.setGameMode();
                        if (gamezop.isBattleGame()) {
                            ConnectionManager_1.ConnectionManager.isBattle = true;
                        }
                        this.game.state.start("PreLoader", true, false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Boot.prototype.mute = function () {
        this.game.sound.mute = true;
    };
    Boot.prototype.resizeCall = function () {
        document.body.style.backgroundColor = "#000000";
        document.body.style.width = window.innerWidth + "px";
        document.body.style.height = window.innerHeight + "px";
        var divGame = document.getElementById("content");
        var newWidth = "100%";
        var newHeight = "100%";
        divGame.style.width = newWidth;
        divGame.style.height = newHeight;
        divGame.style.backgroundColor = "transparent";
        divGame.style.backgroundImage = "url('gzpAssets/tilebg.png')";
        divGame.style.backgroundRepeat = "repeat"; // Repeat the background
        divGame.style.backgroundSize = "auto"; // Optional: keeps the original size
    };
    Boot.prototype.onOrientationChange = function (shouldWeCheckSdkFunctions) {
        if (shouldWeCheckSdkFunctions === void 0) { shouldWeCheckSdkFunctions = true; }
        var width;
        var height;
        if (/iPhone/.test(navigator.userAgent) && shouldWeCheckSdkFunctions) {
            width = document.documentElement.clientWidth;
            height = document.documentElement.clientHeight;
        }
        else {
            width = window.innerWidth;
            height = window.innerHeight;
        }
        if (height > width) {
            document.getElementById("orientation").style.display = "none";
            if (shouldWeCheckSdkFunctions) {
                // gamezop.pause();
                gamezop.unmute();
            }
        }
        else {
            if (!GameConstants_1.GameConstants.isMobile.any()) {
                return;
            }
            document.getElementById("orientation").style.display = "block";
            if (shouldWeCheckSdkFunctions) {
                // gamezop.play();
                gamezop.mute();
            }
        }
    };
    Boot.prototype.unmute = function () {
        if (GameVars_1.GameVars.sound) {
            this.game.sound.mute = false;
        }
    };
    return Boot;
}(Phaser.State));
exports.Boot = Boot;
